module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "action": ""
    }
  }, [(_vm.errorMessage) ? _c('Message', {
    attrs: {
      "message-content": _vm.errorMessage,
      "message-status": "error"
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Youtube or Vimeo Link:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.featured.videoDetails.link),
      expression: "featured.videoDetails.link"
    }],
    attrs: {
      "name": "",
      "placeholder": "Paste a URL link from a Youtube or Vimeo video",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.featured.videoDetails.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.featured.videoDetails, "link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Partner:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "searchable": false,
      "placeholder": "Pick a partner",
      "options": _vm.partners
    },
    model: {
      value: (_vm.featured.partnerId),
      callback: function($$v) {
        _vm.$set(_vm.featured, "partnerId", $$v)
      },
      expression: "featured.partnerId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticClass: "btn btn_green u-fleft u-mr1",
    on: {
      "click": function($event) {
        _vm.updatePartner()
      }
    }
  }, [_vm._v("\n                Update\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn_red u-fleft",
    on: {
      "click": function($event) {
        _vm.confirmToggle()
      }
    }
  }, [_vm._v("\n                Delete\n            ")])])], 1), _vm._v(" "), _c('confirm', {
    attrs: {
      "resource": "featured video",
      "visible": _vm.alertVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.alertVisible = $event
      }
    }
  }), _vm._v(" "), _c('ok', {
    attrs: {
      "resource": "featured video",
      "resource-plural": "featured videos",
      "visible": _vm.okVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.okVisible = $event
      }
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "visible": _vm.loadingVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.loadingVisible = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("\n            Edit featured video\n        ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e8b15f8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e8b15f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Featured/EditFeatured.vue
// module id = 433
// module chunks = 1